var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.prefixCls},[_c('div',{class:(_vm.prefixCls + "-title"),on:{"click":_vm.handleCollapse}},[_c('div',{class:(_vm.prefixCls + "-title-content")},[_vm._t("title")],2),_vm._v(" "),_c('span',{class:(_vm.prefixCls + "-icon")},[_c('Icon',{attrs:{"type":_vm.isCollapse ? 'arrow-up' : 'arrow-down'}})],1)]),_vm._v(" "),_c('CollapseTransition',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isCollapse),expression:"isCollapse"}],class:(_vm.prefixCls + "-content")},[_vm._t("content")],2)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/base/collapse/collapse.vue?vue&type=template&id=05a022c0&
// module id = 110
// module chunks = 0